<template>
    <div class="app-container">
    <el-row class="headTop">
        <el-col :span="2">
          <el-button
            class="goBack"
            style="width:150px"
            @click="goback()"
          >返回上一级</el-button>
        </el-col>
        <el-col :span="2" :offset="20">
          <el-button style="width:140px"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="推荐信息"  :visible.sync="dialogVisible2" width="1000px">
        <el-form :model="formparamInfo" :rules="rules2" ref="formparamInfo" label-width="120px">
           <!-- <el-form-item label="推荐类型" prop="type">
             <el-select v-model="formparamInfo.type" @change="changeGetList(formparamInfo.type)" placeholder="请选择">
                <el-option
                v-for="item in this.tableData"
                :key="item.type"
                :label="item.recommendname"
                :value="item.type"
                ></el-option>
              </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="分店" prop="shopNum">
             <el-select v-model="formparamInfo.shopNum" @change="getInfolist(formparamInfo.shopNum)" placeholder="请选择">
                <el-option
                v-for="item in this.shopList"
                :key="item.shopNum"
                :label="item.name"
                :value="item.shopNum"
                ></el-option>
              </el-select>
          </el-form-item> -->
          <el-form-item label="推荐名称" prop="name">
             <el-select v-model="formparamInfo.shortName" placeholder="请选择">
                <el-option
                v-for="item in this.getPtClassList"
                :key="item.shortName"
                :label="item.name"
                :value="item.shortName"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="推荐数量" prop="number">
            <el-input class="w220" v-model.number="formparamInfo.number" placeholder="请输入推荐数量"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparamInfo')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitSetInfo('formparamInfo')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
        <el-table v-loading="loading" :data="tableData2" height="73vh" border stripe>
          <el-table-column
            label="序号"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column label="推荐大类">
            <template slot-scope="scope">
              <div> {{scope.row.typename}} </div>
            </template>
          </el-table-column>
          <el-table-column label="推荐项目">
            <template slot-scope="scope">
              <div> {{scope.row.name}} </div>
            </template>
          </el-table-column>
          <el-table-column label="分店">
            <template slot-scope="scope">
              <div> {{scope.row.shopnum|caseType}} </div>
            </template>
          </el-table-column>
          <el-table-column label="推荐数量">
            <template slot-scope="scope">
              <div> {{scope.row.number}} </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button style="width:100px"  type="danger" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {
  getRecommendType,
  updateRecommendType,
  getPrivateCourse,
  getAllEJtInfo,
  deleteRecommendinfo, 
  getCardsSells, 
  getRecommendinfo,
  inserteRecommendinfo,
  getTbCourses,
  insertTuancaorec,
  insertTbCourse,
  getShops
} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    var validDate = (rule,value,callback) => {
        if(!this.date[0] || !this.date[1]){
            callback(new Error("请选择日期"))
        }else{
            callback()
        }
    }
    return {
      loading: true,
      dialogVisible: false,
      dialogVisible2: false,
      hideUpload: false,
      type:'',//类型查询
      query:{
      },
      shopNum:'',
      remaNumber:'',
      date:[],//开始时间结束时间
      pickerBeginDateBefore:{
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      shopList:[],//分店
      getPtClassList:[],//私教项目
      startTime:'',
      endTime:'',
      rules:{
        number:[
          {type:'number', required: true, message: '请输入数量', trigger: 'blur' }
        ],
        status:[{ required: true, message: '请选择显示状态', trigger: 'blur' }],
        recommendType:[{ required: true, message: '请选择推荐方式', trigger: 'blur' }],
      },
      rules2:{
        number:[
          {type:'number', required: true, message: '请输入数量', trigger: 'blur' }
        ],
        type:[
          { required: true, message: '请选择推荐类型', trigger: 'change' }
        ],
        shopNum:[
          { required: true, message: '请选择分店', trigger: 'change' }
        ],
        shortName:[
          { required: true, message: '请选择推荐项目', trigger: 'change' }
        ],
      },
      statusType:[
        {lable:'显示',value:1},
        {lable:'不显示',value:0}
      ],
      recommendTypeS:[
        {lable:'手动',value:1},
        {lable:'自动',value:0}
      ],
      timeList:[],
      addType:1,
      newData:[],
      formparamInfo:{
        number: '',
        name:'',
        shortName:'',
        typeName:this.$route.query.name,
        type:this.$route.query.type,
        shopNum:this.$route.query.shopNum,
      },
      formData:{},
      fileList:[],
      tableData:[],
      tableData2:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        page: 1,
        size: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    },
    calssType(value) {
      if (that.options.find(i => {
        return i.code == value
        })) {
        return that.options.find(i => {
            return i.code == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
    this.formparamInfo.type = this.$route.query.type
    this.formparamInfo.shopNum = this.$route.query.shopNum
    if(this.formparamInfo.type=='privateCourse'){
        this.getPtClassList=[]
        this.getPrivateCourse()
      } else if(this.formparamInfo.type=='coach'){
        this.getPtClassList=[]
        this.getAllEJtInfo()
        //获取教练
      } else if(this.formparamInfo.type=='card'){
        this.getPtClassList=[]
        this.getCardsSells()
        //获取会员卡
      } else if(this.formparamInfo.type=='tuancao'){
        //获取团课
        this.getPtClassList=[]
        this.getTbCourses()
      }
  },
  mounted() {
    this.getTableList2()
  },
  methods: {
    goback(){
      this.$router.go(-1)
      // this.$router.push('/siteList')
    },
    // inserteRecommendinfo
    showDialog(){
        this.dialogVisible2 =true
        this.formparamInfo.number = ''
        this.formparamInfo.name = ''
        this.formparamInfo.shortName = ''
        // this.formparamInfo.typeName = ''
    },
    getName(item){
      alert(item)
    },
    // getRecommendinfo
    getTableList2(){
      getRecommendinfo({type:this.$route.query.type,shopNum:this.$route.query.shopNum}).then((res)=>{
        if(res.msg == "success"){
            this.tableData2 = res.data
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
      })
    },
    changeShopData(){
      this.getTableList()
    },
    //根据类型查数据
    queryData(){
      getRecommendinfo({type:this.$route.query.type,shopNum:this.$route.query.shopNum}).then((res)=>{
        if(res.msg == "success"){
            this.tableData2 = res.data
        }
        this.loading = false
      })
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
    getPrivateCourse(){
      getPrivateCourse({shopNum:this.formparamInfo.shopNum}).then((res)=>{
        if(res.msg=='success'){
          for (let i = 0; i < res.data.length; i++) {
            this.getPtClassList.push({name:res.data[i].infI.name,shortName:res.data[i].infI.shortname})
          } 
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    getAllEJtInfo(){
      getAllEJtInfo({shopNum:this.formparamInfo.shopNum}).then((res)=>{
        if(res.msg=='success'){
          for (let i = 0; i < res.data.length; i++) {
            this.getPtClassList.push({name:res.data[i].name,shortName:res.data[i].shortname})
          } 
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    getCardsSells(){
      getCardsSells({shopNum:this.formparamInfo.shopNum}).then((res)=>{
       if(res.msg=='success'){
          for (let i = 0; i < res.data.length; i++) {
            this.getPtClassList.push({name:res.data[i].cardName,shortName:res.data[i].cardShortName})
          } 
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    getTbCourses(){
      getTbCourses({shopNum:this.formparamInfo.shopNum}).then(res=>{
        if(res.msg=='success'){
          for (let i = 0; i < res.data.length; i++) {
            this.getPtClassList.push({name:res.data[i].name,shortName:res.data[i].shortname})
          } 
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    submitSetInfo(formparamInfo){
      this.remaNumber= this.$route.query.num
      if(this.remaNumber < this.tableData2.length+1){
        this.$message.error('当前分店的推荐类型的产品数量已达最大值，不能继续添加')
        return
      } else{
        for (let i = 0; i < this.tableData2.length; i++) {
          if(this.tableData2[i].shortname == this.formparamInfo.shortName){
            this.$message.error('数据重复，不能继续添加')
            return
          }
        }
      }
      this.$refs[formparamInfo].validate(valid => {
        if (valid) {
          for (let j = 0; j < this.getPtClassList.length; j++) {
            if(this.formparamInfo.shortName == this.getPtClassList[j].shortName){
              this.formparamInfo.name = this.getPtClassList[j].name
            }
          }
          inserteRecommendinfo(this.formparamInfo).then(res=>{
            if(res.msg == 'success'){
              this.dialogVisible = false
              this.$message({
                type:'success',
                message:'增加成功'
              })
              this.dialogVisible2 = false
              this.getTableList2()
            } else {
              this.$message({
                type:'error',
                message:res.data
              })
            }
          })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      })
    },
    resetForm(formparamInfo) {
      this.dialogVisible2 = false;
      this.$refs[formparamInfo].clearValidate();
    },
    remove(row){
      this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRecommendinfo({id:row.id}).then(res=>{
          if(res.msg == 'success'){
            this.$message({
              type:'success',
              message:'删除成功'
            })
            this.getTableList2()
          }else{
            this.$message.error(res.data);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    }
  }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// hotInfo.vue?38f95cfc